<form #seriesForm="ngForm" class="d-flex flex-wrap">

  <div class="mr-3">
    <label for="taskDuration">
      Duration
    </label>
    <div>
      <select
      name="taskDurationId"
      class="form-control"
      id="taskDurationSelect"
      #taskDurationSelect="ngModel"
      required
      [(ngModel)]="tmpSeries.defaultDurationHrs"
      (ngModelChange)="durationChange$.next(tmpSeries.defaultDurationHrs);seriesChange$.next(tmpSeries);"
      [ngClass]="{
        'invalid-input':
          taskDurationSelect.invalid &&
          (taskDurationSelect.dirty || taskDurationSelect.touched)
      }"
    >
      <option
        *ngFor="let hrs of taskDurationOptions | keys"
        [ngValue]="hrs|toNumber"
      >
        {{taskDurationOptions[hrs]}}
      </option>
    </select>
    </div>
  </div>

  <div class="mr-3">
    <label for="taskRecurrence" title="Occurances">
      Times
    </label>
    <div class="d-flex flex-row align-items-center">
      <input class="form-control" value="6" size="3" style="width: 3rem;"
      type="number"
      name="maxTaskCnt"
      [(ngModel)]="tmpSeries.maxCnt"
      (ngModelChange)="maxCntChange$.next(tmpSeries.maxCnt);seriesChange$.next(tmpSeries);"
      #maxTaskCnt="ngModel"
      [min]="0"
      >
    </div>
  </div>

  <div [ngClass]="{ 'd-none': tmpSeries.maxCnt <= 1}">
    <label for="taskInterval"
      title="Interval between schedule date and next task occurance">
      Interval
    </label>
    <select
        name="taskIntervalId"
        class="form-control"
        id="taskIntervalSelect"
        #taskIntervalSelect="ngModel"
        required
        [(ngModel)]="tmpSeries.defaultIntervalHrs"
        (ngModelChange)="intervalChange$.next(tmpSeries.defaultIntervalHrs);seriesChange$.next(tmpSeries);"
        [ngClass]="{
          'invalid-input':
            taskIntervalSelect.invalid &&
            (taskIntervalSelect.dirty || taskIntervalSelect.touched)
        }"
      >
        <option
          *ngFor="let hrs of taskIntervalOptions | keys"
          [ngValue]="hrs|toNumber"
        >
          {{taskIntervalOptions[hrs]}}
        </option>
      </select>
  </div>


</form>